import dayjs, { type Dayjs } from '@/utilities/dayjs-config'
import type { DiscountOption as PopsDiscountOption } from '@/types/pops'

export class DiscountOption {
  id: number
  identifier: string
  name: string
  optInStartDate: Dayjs
  optInEndDate: Dayjs
  cbStartDate?: Dayjs
  cbEndDate?: Dayjs
  omdStartDates: Dayjs[]
  numberOfWeeks: number
  omdEndDate: Dayjs
  shopifyDiscountCode: string

  constructor(rawDiscountOption: PopsDiscountOption) {
    this.id = rawDiscountOption.id
    this.identifier = rawDiscountOption.identifier
    this.name = rawDiscountOption.name
    this.optInStartDate = dayjs(rawDiscountOption.opt_in_start_date)
    this.optInEndDate = dayjs(rawDiscountOption.opt_in_end_date)
    this.cbStartDate = rawDiscountOption.cb_start_date
      ? dayjs(rawDiscountOption.cb_start_date)
      : undefined
    this.cbEndDate = rawDiscountOption.cb_end_date
      ? dayjs(rawDiscountOption.cb_end_date)
      : undefined
    this.omdStartDates = rawDiscountOption.omd_start_dates.map((d) => dayjs(d))
    this.numberOfWeeks = rawDiscountOption.number_of_weeks
    this.omdEndDate = dayjs(rawDiscountOption.omd_end_date)
    this.shopifyDiscountCode = rawDiscountOption.shopify_discount_code
  }

  get isOptInWindowOpen() {
    return dayjs().isBetween(
      this.optInStartDate,
      this.optInEndDate,
      'day',
      '[]',
    )
  }

  get isOmdAvailable() {
    return this.omdStartDates.length > 0
  }

  get isCbAvailable() {
    return !!(this.cbStartDate && this.cbEndDate)
  }

  isDateInCbWindow(date: Dayjs) {
    return date.isBetween(this.cbStartDate, this.cbEndDate, 'day', '[]')
  }

  isWeekInOptInDates(week: Dayjs) {
    return this.omdStartDates.some((omdStartDate) =>
      week.isSame(omdStartDate, 'day'),
    )
  }

  isOmdDiscountStillValidThisWeek() {
    const omdEndDate = this.omdEndDate

    const today = dayjs()

    return dayjs(today).isSameOrBefore(omdEndDate, 'week')
  }
}
